import { useState, ChangeEvent, useCallback } from 'react';
import { EmploymentStatusListType } from 'types/employmentStatus';

/**
 * 雇用形態に関するhooks
 * @param initialEmploymentStatusList
 * @returns 雇用形態の値と更新する関数を含むオブジェクト
 */
export const useEmploymentStatus = (
  initialEmploymentStatusList: EmploymentStatusListType[]
) => {
  const [employmentStatusList, setEmploymentStatusList] = useState<
    EmploymentStatusListType[]
  >(initialEmploymentStatusList);

  // 選択中の条件
  const selectedEmploymentStatusIdList = employmentStatusList
    .filter(({ isChecked }) => isChecked)
    .map(({ value }) => value);

  // チェック状態更新処理
  const updateIsCheckEmploymentStatusList = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const checkedList = employmentStatusList.map((employmentStatus) => {
        if (employmentStatus.value !== event.target.value)
          return employmentStatus;

        return {
          ...employmentStatus,
          isChecked: event.target.checked,
        };
      });

      setEmploymentStatusList(checkedList);

      return checkedList
        .filter(({ isChecked }) => isChecked)
        .map(({ value }) => value);
    },
    [employmentStatusList]
  );

  // チェック状態クリア処理
  const clearIsCheckEmploymentStatusList = () => {
    const checkedList = employmentStatusList.map((employmentStatus) => {
      return {
        ...employmentStatus,
        isChecked: false,
      };
    });
    setEmploymentStatusList(checkedList);
  };

  return {
    employmentStatusList,
    selectedEmploymentStatusIdList,
    updateIsCheckEmploymentStatusList,
    clearIsCheckEmploymentStatusList,
  };
};
